const content = "_content_1r8kr_8";
const destructive = "_destructive_1r8kr_34";
const success = "_success_1r8kr_39";
const styles = {
  content,
  destructive,
  success
};
export {
  content,
  styles as default,
  destructive,
  success
};
//# sourceMappingURL=BigIcon.module.css.js.map
